import { uuid4 } from "@sentry/utils";

export const SECTIONS = Object.freeze({
    taskList: "taskList",
    analytics: "analytics",
    activations: "activations",
    audience: "audience",
    messages: "messages",
    overview: "overview",
});
export const SIDEBAR_SECTIONS = Object.freeze({
    createActivation: "createActivations",
    editActivation: "editActivations",
    createAudience: "createAudience",
    editAudience: "editAudience",
    createMessage: "createMessage",
    editMessage: "editMessage",
    clientInfo: "clientInfo",
    batchMode: "batchMode",
});
export const TASKLIST_STATUSES = Object.freeze({
    DONT_REMIND: "Не напоминаем клиентам",
    DONT_REMIND_SERVICE: "Не напоминаем по услугам",
    NEED_TO_CONTACT: "Нужно связаться",
    POSTPONED_COMMUNICATION: "Отложенная коммуникация",
    CONTACTED_AND_DONT_COME: "Связались, но пока не пришли и не записались",
    CONTACTED_AND_COME: "Связались, а потом пришли или записались",
    NEED_TO_CONTACT_TODAY: "Нужно связаться сегодня",
    NEED_TO_CONTACT_YESTERDAY: "Нужно было связаться вчера или ранее",
    IN_PROGRESS: "В очереди на отправку",
    COMMUNICATION_ERROR: "Ошибки отправки",
});

export const MANUAl_COMMUNICATION_DATE_FORMAT = "YYYY-MM-DD";
export const VISIT_STATUSES = Object.freeze({
    ATTENDANCE: "Посещение",
    CANCEL: "Отмена",
    RECORD: "Запись",
});

export const TASKLIST_COMMUNICATIONS_TYPES = Object.freeze({
    NO: "no",
    MESSAGE: "mess",
    PHONE: "phone",
});

export const TASKLIST_ACTION_TYPES = Object.freeze({
    CONTACT: "CONTACT",
    DONT_CONTACT: "DONT_CONTACT",
    REMIND: "REMIND",
    DONT_REMIND: "DONT_REMIND",
    DONT_REMIND_SERVICE: "DONT_REMIND_SERVICE",
    CHANGE_EXPECTED_DATE: "CHANGE_EXPECTED_DATE",
    CHANGE_COMMENT: "CHANGE_COMMENT",
    CHANGE_MODA: "CHANGE_MODA",
    SEND_MESSAGE: "SEND_MESSAGE",
    CHANGE_TEXT_MESSAGE: "CHANGE_TEXT_MESSAGE",
    REMOVE_CLIENT: "REMOVE_CLIENT",
    MAKE_CALL: "MAKE_CALL",
    BATCH_CHANGE_TEXT_MESSAGE: "BATCH_CHANGE_TEXT_MESSAGE",
    BATCH_CONTACT: "BATCH_CONTACT",
    IN_PROGRESS: "IN_PROGRESS",
    BATCH_IN_PROGRESS: "BATCH_IN_PROGRESS",
    COMMUNICATION_ERROR: "COMMUNICATION_ERROR",
    REMOVE_MESS: "REMOVE_MESS",
    IN_PROGRESS_AGAIN: "IN_PROGRESS_AGAIN",
    CONTACT_AFTER_SENDING_MESSAGE: "CONTACT_AFTER_SENDING_MESSAGE",
});
export const COMMUNICATION_ERROR_CODES = Object.freeze({
    "Не валидный формат номера телефона": "INVALID_NUMBER_FORMAT",
    "На телефоне клиента нет WhatsApp": "WHATSAPP_NOT_FOUND",
    "WhatsApp бот не подключен": "DEAD_AUTH",
});
export const TASKLIST_ACTION_COLORS = Object.freeze({
    [TASKLIST_ACTION_TYPES.CONTACT]: "contact",
    [TASKLIST_ACTION_TYPES.CHANGE_EXPECTED_DATE]: "changed",
    [TASKLIST_ACTION_TYPES.DONT_REMIND]: "deleted",
    [TASKLIST_ACTION_TYPES.DONT_CONTACT]: "changed",
    [TASKLIST_ACTION_TYPES.REMIND]: "changed",
    [TASKLIST_ACTION_TYPES.CHANGE_COMMENT]: "changed",
    [TASKLIST_ACTION_TYPES.CHANGE_TEXT_MESSAGE]: "changed",
    [TASKLIST_ACTION_TYPES.BATCH_CHANGE_TEXT_MESSAGE]: "changed",
    [TASKLIST_ACTION_TYPES.BATCH_CONTACT]: "contact",
    [TASKLIST_ACTION_TYPES.REMOVE_CLIENT]: "deleted",
    [TASKLIST_ACTION_TYPES.IN_PROGRESS]: "contact",
    [TASKLIST_ACTION_TYPES.COMMUNICATION_ERROR]: "deleted",
    [TASKLIST_ACTION_TYPES.CONTACT_AFTER_SENDING_MESSAGE]: "contact",
});

export const DEFAULT_ACTIVATIONS_LIMIT = 3;
export const ACTIVATION_LIMIT_TEXT_TURN_ON = "Включить активацию";
export const ACTIVATION_LIMIT_TEXT_TURN_OFF = "Выключить активацию";
export const ACTIVATION_LIMIT_TEXT_LIMIT_EXCEEDED = limit =>
    `В проекте может быть не больше ${limit} включенных активаций. Чтобы включить эту — выключите какую-то другую.`;
export const DEFAULT_TASKLIST_BATCH_MODE_SELECT_LIMIT = 100;
export const ACTIVATION_NAME_MAX_LENGTH = 150;
export const ACTIVATION_DESCRIPTION_MAX_LENGTH = 1024;
export const ACTIVATION_GROUP_MAX_LENGTH = 50;
export const AUDIENCE_NAME_MAX_LENGTH = 150;
export const AUDIENCE_GROUP_MAX_LENGTH = 50;
export const MESSAGE_NAME_MAX_LENGTH = 150;
export const MESSAGE_GROUP_MAX_LENGTH = 50;
export const TASKLIST_CHANGE_COLOR_TIME = 3000; //ms
export const EMTY_AUDIENCE_FILTER = Object.freeze({ id: 1, value: null });
export const EMTY_AUDIENCE_SETTINGS = Object.freeze({ filters: Object.freeze([EMTY_AUDIENCE_FILTER]) });
export const EMTY_ACTIVATION_SETTINGS = Object.freeze({ messageId: null, audienceId: null, description: "" });
export const START_MESSAGE_PART = Object.freeze({
    _id: uuid4(),
    textVariant: "",
    partNumber: 1,
});
export const CHANGE_ACTIVATION_TYPES = Object.freeze({ create: "create", edit: "edit" });
export const CHANGE_BOT_TRIGGER_TYPES = Object.freeze({ create: "create", edit: "edit" });
export const CHANGE_KPI_SETTING_TYPES = Object.freeze({ create: "create", edit: "edit" });
export const EDIT_MASTER_TYPE = Object.freeze({ create: "create", edit: "edit" });
export const DEFAULT_MAX_ACTVATIONS_COUNT = 3;
export const DEFAULT_KPI_SETTING = {
    name: "",
    description: "",
    is_default: false,
    scheme: {
        convertion_range_sa: [],
        staff_action_value: {
            communication: {
                0: {
                    default: {
                        fixed: 0,
                    },
                },
            },
            postponed: {
                0: {
                    default: {
                        fixed: 0,
                    },
                },
            },
            banned: {
                0: {
                    default: {
                        fixed: 0,
                    },
                },
            },
        },
        record_value: {
            default: {
                fixed: 0,
            },
        },
        revenue_range_visit: [],
        visit_value: {
            default: {
                0: {
                    default: {
                        fixed: 0,
                        percent: 0,
                    },
                },
            },
        },
    },
};
export const DEFAULT_YC_KPI_SETTING = {
    name: "",
    description: "",
    is_default: false,
    scheme: {
        convertion_range_sa: [],
        staff_action_value: {
            communication: {
                0: {
                    default: {
                        fixed: 0,
                    },
                },
            },
            postponed: {
                0: {
                    default: {
                        fixed: 0,
                    },
                },
            },
            banned: {
                0: {
                    default: {
                        fixed: 0,
                    },
                },
            },
            opz: {
                0: {
                    default: {
                        fixed: 0,
                    },
                },
            },
        },
        record_value: {
            default: {
                fixed: 0,
            },
        },
        revenue_range_visit: [],
        visit_value: {
            default: {
                0: {
                    default: {
                        fixed: 0,
                        percent: 0,
                    },
                },
            },
        },
    },
};

export const KPI_NAME_MAX_LENGTH = 150;
export const KPI_DESCRIPTION_MAX_LENGTH = 1024;

export const MESSAGE_VARS = Object.freeze([
    // { id: '{name}' },
    // { id: '{имя-пользователя}' },
    // { id: '{дата-мероприятия}' },
    // { id: '{cсылка-на-отзывы}' },
    // { id: '{название-подарка}' },
    // { id: '{ссылка-на-онлайн-запись}' },
    // { id: '{название-салона}' },
    // { id: '{адрес-салона}' },
    // { id: '{контактный-телефон}' },
    { id: "{name}" },
    { id: "{имя-пользователя}" },
    { id: "{имя-руководителя}" },
    { id: "{имя-администратора}" },
    { id: "{название-салона}" },
    { id: "{адрес-салона}" },
    { id: "{ссылка-на-отзывы}" },
    { id: "{контактный-телефон}" },
    { id: "{ссылка-на-онлайн-запись}" },
    { id: "{наименование-специалиста}" },
    { id: "{наименование-специалиста-2}" },
    { id: "{наименование-специалиста-3}" },
    { id: "{наименование-специалиста-4}" },
    { id: "{дата-мероприятия}" },
    { id: "{дата-мероприятия-2}" },
    { id: "{дата-мероприятия-3}" },
    { id: "{название-услуги}" },
    { id: "{название-услуги-2}" },
    { id: "{название-услуги-3}" },
    { id: "{название-услуги-4}" },
    { id: "{название-услуги-5}" },
    { id: "{название-подарка}" },
    { id: "{название-подарка-2}" },
    { id: "{название-подарка-3}" },
    { id: "{название-подарка-4}" },
    { id: "{название-подарка-5}" },
    { id: "{название-подарка-6}" },
    { id: "{название-подарка-7}" },
    { id: "{название-подарка-8}" },
    { id: "{название-подарка-9}" },
    { id: "{название-подарка-10}" },
    { id: "{название-подарка-11}" },
    { id: "{название-подарка-12}" },
    { id: "{название-подарка-13}" },
    { id: "{название-подарка-14}" },
    { id: "{название-подарка-15}" },
    { id: "{название-подарка-16}" },
    { id: "{название-подарка-17}" },
    { id: "{название-подарка-18}" },
    { id: "{название-подарка-19}" },
    { id: "{название-подарка-20}" },
    { id: "{название-подарка-21}" },
    { id: "{название-подарка-22}" },
    { id: "{название-подарка-23}" },
    { id: "{название-подарка-24}" },
    { id: "{название-подарка-25}" },
    { id: "{название-подарка-26}" },
    { id: "{название-подарка-27}" },
    { id: "{название-подарка-28}" },
    { id: "{название-подарка-29}" },
    { id: "{название-подарка-30}" },
    { id: "{название-подарка-31}" },
    { id: "{название-подарка-32}" },
    { id: "{название-подарка-33}" },
    { id: "{название-подарка-34}" },
    { id: "{название-подарка-35}" },
    { id: "{название-подарка-36}" },
    { id: "{название-подарка-37}" },
    { id: "{название-подарка-38}" },
    { id: "{название-подарка-39}" },
    { id: "{название-подарка-40}" },
    { id: "{название-подарка-41}" },
    { id: "{название-подарка-42}" },
    { id: "{название-подарка-43}" },
    { id: "{название-подарка-44}" },
    { id: "{название-подарка-45}" },
    { id: "{название-подарка-46}" },
    { id: "{название-подарка-47}" },
    { id: "{название-подарка-48}" },
    { id: "{название-подарка-49}" },
    { id: "{название-подарка-50}" },
]);

export const SCHEDULED_REPORT_NAME_MAX_LENGTH = 150;

export const AUDIENCE_BOOLEAN_SELECT_DEFAULT_LIST = Object.freeze({
    trueText: "Да",
    falseText: "Нет",
});

/** Ключ списка коннекторов проекта (WhatsApp / Telegram / MAX) для селектов в схемах аудитории. */
export const MESSAGING_CHANNELS_FLAT_LIST_KEY = "messaging_channels_flat";

export const SUBSCRIBERS_GROWTH_SYNTHETIC_AUDIENCE_IDS = Object.freeze({
    invite_unsubscribed: 6854,
    safe_mailing: 6854,
});

export const AUDEINCE_ADDITIONAL_SETTINGS = {
    is_technical: {
        defaultValue: false,
        canEdit: true,
        schema: [
            {
                type: "text",
                text:
                    "Учитывать ли коммуникации по этой активации в фильтрах других активаций? —",
            },
            {
                type: "select",
                label: "",
                multiple: false,
                customList: [
                    {
                        id: false,
                        name: "Да",
                    },
                    {
                        id: true,
                        name: "Нет",
                    },
                ],
                valueField: "is_technical",
                defaultValue: false,
            },
            {
                text: "Если выбрать НЕТ, то для других активаций этой рассылки как будто не будет существовать. Это полезно для новостных/поздравительных рассылок, которые не должны блокировать основные рассылки",
                type: "popupHint"
            }
        ],
    },
    no_comms_after_last_visit: {
        defaultValue: false,
        canEdit: true,
        schema: [
            {
                type: "text",
                text:
                    "Должны ли в новую активацию попадать клиенты, с которыми после прошлого визита уже связывались по другим активациям? —",
            },
            {
                type: "select",
                label: "",
                multiple: false,
                customList: [
                    {
                        id: false,
                        name: "Да",
                    },
                    {
                        id: true,
                        name: "Нет",
                    },
                ],
                valueField: "no_comms_after_last_visit",
                defaultValue: false,
            },
        ],
    },
    last_communication_delay: {
        defaultValue: 5,
        canEdit: true,
        schema: [
            {
                type: "text",
                text:
                    "Если клиенту уже отправили сообщение по другой активации, сколько дней должно пройти, чтобы он мог получить сообщение по этой? —",
            },
            {
                type: "numberInput",
                valueField: "last_communication_delay",
                defaultValue: 5,
            },
        ],
    },
    last_visit_from: {
        defaultValue: 0,
        canEdit: true,
        schema: [
            {
                type: "text",
                text: "Сколько дней должно пройти с даты последнего визита на любую услугу? — \n",
            },
            {
                type: "text",
                text: "от",
            },
            {
                type: "numberInput",
                valueField: "last_visit_from",
                defaultValue: 0,
                width: 70,
            },
            {
                type: "text",
                text: "до",
            },
            {
                type: "numberInput",
                valueField: "last_visit_to",
                width: 70,
                defaultValue: 2000,
            },
        ],
    },
    last_visit_to: {
        defaultValue: 2000,
        canEdit: true,
        hidden: true,
    },
    no_future_records: {
        defaultValue: true,
        canEdit: true,
        schema: [
            {
                type: "text",
                text: "Если клиент уже записан на будущее, он должен попасть в эту активацию? —",
            },
            {
                type: "select",
                label: "",
                multiple: false,
                customList: [
                    {
                        id: false,
                        name: "Да",
                    },
                    {
                        id: true,
                        name: "Нет",
                    },
                ],
                valueField: "no_future_records",
                defaultValue: true,
            },
        ],
    },
    regularity: {
        defaultValue: "one_time",
        canEdit: false,
        schema: [
            {
                type: "text",
                text:
                    "После того, как с клиентом свяжутся по этой активации, когда он сможет попасть в неё снова? —",
            },
            {
                type: "select",
                label: "",
                multiple: false,
                showTooltip: true,
                width: 458,
                customList: [
                    {
                        id: "one_time",
                        name: "Никогда",
                    },
                    {
                        id: "monthly",
                        name: "С 1 числа следующего месяца",
                    },
                    {
                        id: "after_visit",
                        name: "После очередного посещения",
                    },
                ],
                valueField: "regularity",
                defaultValue: "one_time",
            },
            {
                text: "Вы выбираете, когда надо снова проверить уже получившего эту рассылку клиента по всем фильтрам активации. Если пройдёт проверку, появится в списке 'нужно связаться'. Если нет — система просто подождёт следующего подходящего момента.",
                type: "popupHint"
            },
        ],
    },
    consider_activation_priority: {
        defaultValue: false,
        canEdit: false,
        schema: [
            {
                type: "text",
                text:
                    "Должны ли клиенты этой активации показываться по правилам приоритетов? Если на активацию работают приоритеты, в ней могут отображаться не все попадающие клиенты, пока она стоит не на первом месте. А клиенты, отобразившиеся в ней, исчезнут из других активаций. —",
            },
            {
                type: "select",
                label: "",
                multiple: false,
                customList: [
                    {
                        id: true,
                        name: "Да",
                    },
                    {
                        id: false,
                        name: "Нет",
                    },
                ],
                valueField: "consider_activation_priority",
                defaultValue: false,
            },
        ],
    },
    force_comm: {
        defaultValue: false,
        canEdit: true,
        schema: [
            {
                type: "text",
                text:
                    'Должны ли клиенты из списка "Не напоминаем" попадать в новую активацию, если они подойдут под условия? —',
            },
            {
                type: "select",
                label: "",
                multiple: false,
                customList: [
                    {
                        id: true,
                        name: "Да",
                    },
                    {
                        id: false,
                        name: "Нет",
                    },
                ],
                valueField: "force_comm",
                defaultValue: false,
            },
        ],
    },
};

export const BOT_TRIGGER_CARDS = Object.freeze({
    afterRecord: {
        title: "Новая запись",
        description:
            "Клиент записался к вам в салон🌝+🌚.\nСообщение сразу после записи для первичных🌝 и повторных🌚 клиентов.",
    },
    afterRecordNew: {
        title: "Новая запись для клиентов, которые никогда не были в салоне",
        description:
            "Клиенты, которые никогда не были в салоне🌝.\nСообщение сразу после записи для тех, кто не имеет посещений.\nНе забудьте включить 🌚, чтобы клиенты, которые уже были у вас, тоже получали уведомление.",
    },
    afterRecordPrev: {
        title: "Новая запись для клиентов, у которых был хотя бы 1 визит",
        description:
            "Клиенты, которые уже были у вас в салоне🌚.\nСообщение сразу после записи для тех, у кого было хотя бы одно посещение.\nНе забудьте включить 🌝, чтобы клиенты, которые не были у вас, тоже получали уведомление.",
    },
    notificBeforeRecord1Day: {
        title: "Запрос подтверждения за сутки",
        description:
            "Сообщение с просьбой подтвердить запись за сутки до записи, но не раньше 10:00 и не позже 21:00.",
    },
    notificBeforeRecord2Hours: {
        title: "Напоминание за 2 часа ",
        description:
            "Сообщение за два часа до записи. Если запись утренняя, то сообщение отправляется накануне вечером",
    },
    afterRecordCancelled: {
        title: "Отмена записи",
        description: "Сообщение в момент удаления записи или отмены записи",
    },
    afterRecordConfirmed: {
        title: "Подтверждение записи",
        description: "Сообщение в момент подтверждения записи",
    },
    afterRecordTimeChanged: {
        title: "Перенос времени записи",
        description:
            "Сообщение при изменении времени записи. Сообщения не отправляются, если запись отменена или визит уже начался",
    },
    afterRecordDataChanged: {
        title: "Изменения записи",
        description:
            "Сообщение при изменении мастера. Сообщения не отправляются, если запись отменена или визит уже начался",
    },
    afterVisit: {
        title: "Запрос оценки визита",
        description:
            "Сообщение с просьбой оценить визит в момент завершения записи. При положительной оценке — предложение оставить отзыв, при отрицательной — сообщение управляющему",
    },
    afterRecordClientCome: {
        title: "Клиент пришёл",
        description: "Сообщение в момент, когда нажали кнопку «Клиент пришёл»",
    },
    RequestFeedback: {
        title: "Запрос обработки рекламации",
        description: "Сообщение с просьбой повторно оценить визит после обработки негатива.",
    },
});
